<template>
    <v-autocomplete
            :label="label"
            :value="value"
            :items="items"
            :multiple="multiple"
            item-text="desig"
            item-value="id"
            hide-details
            clearable
            hide-selected
            chips
            @input="actualizaValor($event)"
    >
        <template slot="selection" slot-scope="data">
            <v-chip :close="multiple" @input="data.parent.selectItem(data.item)"
                    :selected="data.selected" class="chip--select-multi" :key="JSON.stringify(data.item)">
                <v-avatar>
                    <v-icon :color="data.item.color">{{ data.item.icono }}</v-icon>
                </v-avatar>
                {{ data.item.desig }}
            </v-chip>
        </template>
        <template slot="item" slot-scope="data">
            <template>
                <v-list-tile-action>
                    <v-icon :color="data.item.color">{{ data.item.icono }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.desig"></v-list-tile-title>
                </v-list-tile-content>
            </template>
        </template>
    </v-autocomplete>
</template>
<script>
    import mixinPresupuesto from '../mixins/presupuesto'

    export default {
        name: 'estado-select',
        props: ['multiple', 'value', 'chips', 'label'],
        mixins: [mixinPresupuesto],
        data() {
            return {
                items: []
            }
        },
        mounted() {
            this.estadosListado(r => {
                this.items = r;
            }, err => {
                console.log(err)
            })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/EstadoSelect.vue